import type { AppNotification } from '../domain/models'

export const seedNotifications: readonly AppNotification[] = [
  {
    id: 'notification-show-01',
    kind: 'show',
    title: 'Dallas check-in is open',
    body: 'Connected pass holders can check in from the show card.',
    showId: 'show-01',
    createdAt: '2027-10-14T17:00:00-05:00',
  },
  {
    id: 'notification-community-01',
    kind: 'community',
    title: 'The Dallas board is moving',
    body: 'New Fits, Merch, and arrival posts are on the city feed.',
    showId: 'show-01',
    createdAt: '2027-10-14T17:30:00-05:00',
  },
  {
    id: 'notification-system-01',
    kind: 'system',
    title: 'Your route stays with you',
    body: 'Saved stops, posts, and passport marks are here when you come back.',
    createdAt: '2027-10-14T15:00:00-05:00',
  },
] as const
